import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Form,
  Icon,
  Typography,
  Col,
  Row,
  Button,
  message,
} from 'antd';
import QueueAnim from 'rc-queue-anim';
import { Redirect, Link } from 'react-router-dom';

import { Logo } from '../../Page';

import styles from './Reset.module.css';

const FormItem = Form.Item;
const { Title } = Typography;

message.config({
  top: 12,
  duration: 3
});

class Reset extends Component {
  state = {
    redirectToPreviousRoute: false
  };

  handleRedirect = () => {
    if (this.props.success) {
      this.success(this.props.payload);

      setTimeout(() => {
        this.setState({
          redirectToPreviousRoute: true
        })
      }, 3000);
    }

    if (this.props.error) {
      this.error(this.props.error);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      const payload = {
        email: values['e-mail'],
      };

      if (!err) {
        this.props.resetPassword(payload, this.handleRedirect);
      }
    });
  };

  success = (msg) => {
    message.success(msg);
  };

  error = (msg) => {
    message.error(msg);
  };

  render() {
    const {
      protocol,
      hostname
    } = window.location;
    const logo = `${protocol}//${hostname}/logo/${hostname}/logo.png`;
    const { getFieldDecorator } = this.props.form;
    const { redirectToPreviousRoute } = this.state;
    const { from } = this.props.location.state || { from: { pathname: '/login' }};
    const animationOptions = {
      delay: 400,
      duration: 300,
      animConfig: [
        { opacity: [1, 0], translateY: [0, -70] },
        { opacity: [1, 0], translateY: [0, 70] }
      ]
    };

    if (redirectToPreviousRoute) {
      return <Redirect to={from} />
    }

    return (
      <QueueAnim {...animationOptions}>
        <div key="step" className={styles['auth-page']}>
          <Logo
            src={logo}
            alt=""
          />
          <Title>Reset Password</Title>
          <Form
            className="form"
            onSubmit={this.handleSubmit}
          >
            <FormItem>
              {getFieldDecorator('e-mail', {
                rules: [
                  { type: 'email', message: 'Enter valid e-mail' },
                  { required: true, message: 'Enter e-mail' },
                ],
              })(
                <Input
                  prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="E-mail"
                  size="large"
                  autoFocus
                />,
              )}
            </FormItem>
            <FormItem>
              <Row>
                <Col xs={8}>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                  >
                    Reset
                  </Button>
                </Col>
                <Col
                  xs={16}
                  className={styles['btn-container']}
                >
                  <Link to="/signup">Sign Up</Link>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </div>
      </QueueAnim>
    );
  }
};

Reset.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

export default Reset = Form.create({})(Reset);
